import {getCurrencyForLocale, currencySymbolMap} from '@/utils/currency-formatter'
import {useLocale} from '@helios/shared/providers/locale'

const useCurrency = () => {
    const currentLocale = useLocale()
    const code = getCurrencyForLocale(currentLocale.code)
    const symbol = currencySymbolMap[code]

    return {
        code,
        symbol,
    }
}

export default useCurrency
